import { computed, Injectable, signal } from '@angular/core';
import { PostLoginWorkflow } from '@core/sso/models/post-login-workflow.enum';

@Injectable({ providedIn: 'root' })
export class CurrentLoginFlowService {
  readonly currentLoginFlow = signal<PostLoginWorkflow | undefined>(undefined);
  readonly isOpenIdConnectFlow = computed(() => this.currentLoginFlow() === PostLoginWorkflow.OpenIdConnect);
  readonly isZendeskLoginFlow = computed(() => this.currentLoginFlow() === PostLoginWorkflow.KaseyaZendeskLogin);
}
